import Text from "common/Typography/Text";
import styled from "styled-components";
import { typography } from "@shared/common/Themes/typography";

export const FormFieldTitle = styled(Text).attrs({
  as: "div",
})`
  font-size: ${(p) => p.theme.typography.fontSizes.S};
  font-weight: ${(p) => p.theme.typography.fontWeights.MEDIUM};
  margin-bottom: 8px;
  display: flex;
  align-items: center;

  ${(p) =>
    p.onClick &&
    `
  cursor: pointer;
  `}
`;

export const ErrorText = styled(Text).attrs({
  $size: typography.fontSizes.S,
})`
  color: ${(p) => p.theme.colors.red};
  margin-top: 4px;
`;
